import { inject, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';
import { resolveRedirectTarget } from './redirect-target';
import { GetExpires } from './services/storage-data.utility';
import { UserProvider } from './services/user.provider';

/**
 * checks locally, with no network call, whether the current token's own expiry has already passed.
 * @returns {boolean} true if the token is expired or missing an expiry.
 */
export function IsTokenExpired(): boolean {
  const expiresAt = GetExpires();
  return !expiresAt || Date.now() >= expiresAt;
}

/**
 * redirects an authenticated user with an expired token to /logout, preserving the current url.
 */
export function redirectIfSessionExpired(
  router: Router,
  userProvider: UserProvider
): void {
  if (!userProvider.isAuthenticated() || !IsTokenExpired()) {
    return;
  }

  router.navigate(['/logout'], {
    queryParams: {
      sessionExpired: true,
      redirectTo:
        resolveRedirectTarget(
          window.location.pathname + window.location.search
        ) ?? undefined,
    },
    replaceUrl: true,
  });
}

/**
 * registers the session expiry check to run once at app bootstrap.
 * @returns {EnvironmentProviders} the app initializer provider.
 */
export function provideSessionExpiryCheck() {
  return provideAppInitializer(() => {
    redirectIfSessionExpired(inject(Router), inject(UserProvider));
  });
}
